import React from 'react'
import { connect } from 'react-redux'
import { Tab } from 'semantic-ui-react'
import LiveVideoChat from './LiveVideoChat'
import Chart from './Chart'
import { getQuestionStatus } from '../reducers/questions'
import Status from '../reducers/questions/status'
import BannedList from './BannedList';
import UserSearch from './UserSearch'
import {getUsers} from '../reducers/users/index'
import {getNumberOfChatters} from '../reducers/chat'


class ChatChartTab extends React.Component {
    state = { activeIndex: 0}

    componentDidMount(){
            this.props.onMount(this.props.socket);
    }

    componentDidUpdate(prevProps) {
        const { questionStatus, canDownload } = this.props

        if (prevProps.questionStatus !== questionStatus) {
            switch (questionStatus) {
                case Status.WAITING_BETS:
                    this.setState({ activeIndex: 1 })
                    break;

                case Status.TO_ASK:
                    this.setState({ activeIndex: 0 })
                    break;

                case Status.ASKED:
                    if (canDownload)
                        this.setState({ activeIndex: 1 })
                    break;

                default:
                    break;
            }
        }
    }

    handleChange = (e, { activeIndex }) => {
            this.setState({ activeIndex:activeIndex})
    }

    render() {
        const { activeIndex } = this.state
        const { withAnswers, canDownload } = this.props

        const panes = [];
        panes.push({ menuItem: 'Chat', pane: <Tab.Pane key={0} style={{ height: '500px' }}><LiveVideoChat enabled = {this.props.chatEnabled} isCond = {true} canChat={true}/></Tab.Pane> });
        if (this.props.game_id) panes.push({ menuItem: 'Classifica', pane: <Tab.Pane key={1}><Chart withAnswers={withAnswers} canDownload={canDownload} /></Tab.Pane> });    
        panes.push({ menuItem: 'Banned List', pane: <Tab.Pane key={2} ><BannedList/></Tab.Pane> });
        panes.push({ menuItem: 'Cerca utente', pane: <Tab.Pane key={3} style={{ minHeight: '486px'}}><UserSearch/></Tab.Pane> });
     
        return <Tab panes={panes} 
            activeIndex={activeIndex} 
            onTabChange={this.handleChange}
            renderActiveOnly={false}
            style={{ height: '100%' }} />
    }
}


const mapStateToProps = (state, { withAnswers, canDownload, game_id }) => ({
    questionStatus: game_id?getQuestionStatus(state.currentQuestionId, game_id, state):null,
    chart: state.chart,
    socket:state.socket,
    withAnswers,
    canDownload
})

const mapDispatchToProps = (dispatch) => ({
    onMount: (socket) => dispatch(getUsers(socket), getNumberOfChatters(socket))
})


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ChatChartTab)


// WEBPACK FOOTER //
// ./src/components/ChatChartTabs.js